export const server = 'https://track-me-backend.onrender.com'
export const foodImageApi = 'https://api.edamam.com'
export const foodNutrientsApi = 'https://api.calorieninjas.com'
export const imageApi = 'https://pixabay.com/api'
export const excerciseApi = 'https://trackapi.nutritionix.com'
// https://track-me-backend.onrender.com